<!-- accoutn start -->
   $(function() {
    function passwordCheck(password) {
    if (password.length >= 8){
        strength += 1;
        $('.maxchar').css({"opacity":"1"}).delay(500);
    }else{
      $('.maxchar').css({"opacity":"0"}).delay(500);
    }
    if ((password.match(/(?=.*[!,%,&,@,#,$,^,*,?,_,~,<,>,])/)) && (password.match(/(?=.*[0-9])/))){
      strength += 1;
         $('.numspec').css({"opacity":"1"}).delay(500);
    }else{
      $('.numspec').css({"opacity":"0"}).delay(500);
    }
    if (password.match(/(?=.*[a-z])/) && password.match(/(?=.*[A-Z])/)){
      strength += 1;
         $('.mixcase').css({"opacity":"1"}).delay(500);
    }else{
      $('.mixcase').css({"opacity":"0"}).delay(500);
    }
    displayBar(strength);
  }
  function displayBar(strength) {
    switch (strength) {
      case 1:
        $("#password-strength span").css({
          "width": "20%",
          "background": "#de1616"
        });
        $('.pw_status').html('<span style="color:#de1616">Weak</span>');
        break;
      case 2:
        $("#password-strength span").css({
          "width": "40%",
          "background": "#de1616"
        });
        $('.pw_status').html('<span style="color:#de1616">Weak</span>');
        break;
      case 3:
        $("#password-strength span").css({
          "width": "60%",
          "background": "#FFA200"
        });
        $('.pw_status').html('<span style="color:#FFA200">Good</span>');
        break;
      case 4:
        $("#password-strength span").css({
          "width": "100%",
          "background": "#06bf06"
        });
        $('.pw_status').html('<span style="color:#06bf06">Strong</span>');
        break;
      default:
        $("#password-strength span").css({
          "width": "0",
          "background": "#de1616"
        });
    }
  }
    $("[data-strength]").keyup(function() {
      var password = $(this).val();
      if (password == '' || password == null){
        strength = 0;
        $('.pw_status span').empty();
      }else{
       strength = 1; 
      }
      passwordCheck(password);
    });
  });  
<!-- accoutn end -->